import axios from "axios";
import { Constants } from "./services/Constants";
import AuthService from "./services/AuthService";

let isRefreshing = false;
let cancelSource = axios.CancelToken.source();

export const http = axios.create({
  // baseURL: Constants.employeeApiRoot,
  baseURL: Constants.employeeApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpAuth = axios.create({
  // baseURL: Constants.employeeApiRoot,
  baseURL: Constants.authApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpIdentityApiRoot = axios.create({
  baseURL: Constants.identityApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpBlobServiceApiRoot = axios.create({
  baseURL: Constants.blobServiceApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "multipart/form-data",
  },
});

export const httpBlobGetServiceApiRoot = axios.create({
  baseURL: Constants.blobServiceApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpChargebeeApiRoot = axios.create({
  baseURL: Constants.chargebeeApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpStripeApiRoot = axios.create({
  baseURL: Constants.stripeApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export const httpCompany = axios.create({
  // baseURL: Constants.employeeApiRoot,
  baseURL: Constants.companywiseApiRoot,
  headers: {
    Authorization: `Bearer ${new AuthService().getToken()}`,
    accept: "*/*",
    "Content-Type": "application/json",
  },
});


// Add a response interceptor to handle token refresh and retry failed requests
function setupResponseInterceptor(instance) {
  // instance.interceptors.request.use((config) => {
  //   config.cancelToken = cancelSource.token;
  //   return config;
  // });

  // instance.interceptors.response.use(
  //   (res) => res,
  //   async (error) => {
  //     const originalRequest = error.config;
  
  //     if (error.response?.status === 401 && !originalRequest._retry) {
  //       originalRequest._retry = true;
  
  //       if (!isRefreshing) {
  //         isRefreshing = true;
  //         cancelSource.cancel("Token expired. Cancelling all requests.");
  //         cancelSource = axios.CancelToken.source();
  
  //         try {
  //           const authService = new AuthService();
  //           authService.signinRedirect(); // redirect to login
  //         } catch (err) {
  //           return Promise.reject(err);
  //         } finally {
  //           isRefreshing = false;
  //         }
  //       }
  
  //       return new Promise(() => {}); // keep other 401 calls waiting silently
  //     }
  
  //     return Promise.reject(error);
  //   }
  // );
}

// Apply the interceptor to httpAuth and other instances as needed
setupResponseInterceptor(httpAuth);
setupResponseInterceptor(http);
setupResponseInterceptor(httpIdentityApiRoot);
setupResponseInterceptor(httpBlobServiceApiRoot);
setupResponseInterceptor(httpBlobGetServiceApiRoot);
setupResponseInterceptor(httpChargebeeApiRoot);
setupResponseInterceptor(httpStripeApiRoot);
setupResponseInterceptor(httpCompany);